import styled, { css } from "styled-components";
import { ReactComponent as DownIcon } from "../../../assets/images/svg/down-arrow.svg";
import { NavLink } from "react-router-dom";
import { Box } from "@mui/material";

export const DropdownTrigger = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownMenu = styled.div`
  display: ${(props) => (props?.$open ? "flex" : "none")};
  position: absolute;
  flex-direction: column;
  top: 100%;
  left: 20px;
  background-color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  border-radius: 12px;
  gap: 8px;
  padding: 12px;

  @media (max-width: 1040px) {
    box-shadow: none;
    gap: 16px;
  }
`;

export const DownIconStyled = styled(DownIcon)`
  width: 20px;
  height: 20px;
  margin-left: 8px;
  transition: transform 0.3s ease;
  transform: rotate(${(props) => (props.$isOpen ? "180deg" : "0deg")});

  & path {
    stroke: ${(props) =>
      props?.$isActive
        ? props?.theme?.colors?.secondaryOpaque
        : props?.theme?.colors?.dark};
    stroke-width: 1;
  }
`;

export const HeaderNavigationItemIconContainer = styled(Box)``;

export const DropdownNavigationItemIconTitle = styled(Box)`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  font-stretch: expanded;
  color: ${(props) => props?.theme.colors.textColor};

  ${(props) =>
    props?.$isActive &&
    css`
      border-bottom: 1px solid ${(props) => props?.theme.colors.secondaryOpaque};
      color: ${(props) => props?.theme.colors.secondaryOpaque};
    `}

  ${(props) =>
    props?.$highlightTitle &&
    css`
      color: ${(props) => props?.theme.colors.secondaryOpaque};
    `}

    @media (max-width: 1040px) {
    font-weight: 300;
  }
`;

export const DropdownNavigationItemContainer = styled(NavLink)`
  display: flex;
  justify-content: center;
  text-decoration: none;
  align-items: center;
  width: fit-content;
  cursor: pointer;

  &[aria-checked="true"] ${DropdownNavigationItemIconTitle} {
    font-weight: 700;
  }
`;
